import memoizeFormatConstructor from 'intl-format-cache';

// Memoize Intl.DateTimeFormat creation for improved performance.
const getDateFormat = memoizeFormatConstructor(Intl.DateTimeFormat);

const FormatNumber = {
  install(Vue) {
    Vue.mixin({
      methods: {
        $formatDate(value, options) {
          return getDateFormat(this.$store.getters.locale, options)
            .format(new Date(Date.parse(value)));
        },
      },
    });
  },
};

export default FormatNumber;
